import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PluckingAndSundryLabourChecklist } from './Pages'

export const PluckingAndSundryLabourChecklistReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PluckingAndSundryLabourChecklist} />
    </Fragment>
)